import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertColor } from "@mui/material/Alert";

interface SnackbarProps {
  variant: AlertColor;
  open: boolean;
  handleClose: () => void;
  message: string;
}

export default function YSSnackBar({
  variant,
  open,
  message,
  handleClose,
}: SnackbarProps) {
  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        autoHideDuration={10000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={variant}>
          {message}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
